import { Col, Form, Input, Row, Select } from "antd";
import secureLocalStorage from "react-secure-storage";
import AddEditForm from "../../../components/molecules/Forms/addEditForm";
import { submitDepartmentThunk } from "../../../store/thunks/departmentsThunk";
import { useDispatch } from "react-redux";

const AddDepartment = ({ editData, statuses, onSuccess }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const slsLIUId = secureLocalStorage.getItem("lIUId");

  const onSubmit = async (values, editData) => {
    const isEdit = Boolean(editData);
    await dispatch(
      submitDepartmentThunk({
        ...(isEdit && { id: editData.key }),
        name: values.name,
        status: isEdit ? values.status : "ACTIVE",
        historySource: "backend",
        historyAction: isEdit ? "update" : "create",
        historyUserID: slsLIUId,
      }),
    ).unwrap();
  };

  return (
    <AddEditForm
      form={form}
      editData={editData}
      onSubmit={onSubmit}
      onSuccess={onSuccess}
      successMessages={{
        create: "Department created successfully",
        update: "Department updated successfully",
      }}
      fields={
        <>
          <Row className="pb-16" gutter={[12, 12]}>
            <Col xs={24} sm={24} md={24} lg={24}>
              <Form.Item
                label="Name"
                name="name"
                className="m-0"
                rules={[{ required: true, message: "Please enter the name!" }]}
              >
                <Input placeholder="Enter Department Name" className="w-100" />
              </Form.Item>
            </Col>

            {editData && (
              <Col span={24}>
                <Form.Item
                  label="Status"
                  name="status"
                  className="m-0"
                  rules={[
                    { required: true, message: "Please select a status!" },
                  ]}
                >
                  <Select
                    showSearch
                    allowClear
                    options={statuses}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input?.toLowerCase())
                    }
                  />
                </Form.Item>
              </Col>
            )}
          </Row>
        </>
      }
    />
  );
};

export default AddDepartment;
